$(document).ready(function () {
  $("body").on(
    "keyup",
    '.additional_properties .propeties input[type="text"]',
    function () {
      if (
        $(".shopify-product-form").find('[name="' + $(this).attr("name") + '"]')
          .length > 0
      ) {
        $(".shopify-product-form")
          .find('[name="' + $(this).attr("name") + '"]')
          .val($(this).val());
      } else {
        $(".shopify-product-form").append(
          '<input type="hidden" name="' +
            $(this).attr("name") +
            '" class="stitched_properties" value="' +
            $(this).val() +
            '">',
        );
      }
      if ($(this).val().length == 0) {
        $(".shopify-product-form")
          .find('[name="' + $(this).attr("name") + '"]')
          .remove();
      }
    },
  );

  $(".checkbox").click(function () {
    if (
      this.checked &&
      $(".mul").length > 0 &&
      $("input:checkbox:checked").length > 0
    ) {
      var multNum1 = $(".mul").val();
      var multNum = $("input:checkbox:checked").val();
      let number = multNum1 * multNum;
      $(".mul").val(number);
    } else {
      $(".mul").val(1);
    }
  });

  $(".product-info__property:first input").addClass("checkboxnew");
  $(".checkboxnew").click(function () {
    if (this.checked) {
      $(".mul").val(1);
      // $('.price-list.price-list--lg sale-price.text-lg').text('₹ '+price);
    }
  });
  // $('input:checkbox').click(function(){
  //   var $inputs = $('input:checkbox')
  //   $inputs.not(this).prop('checked', false);
  //   $('.mul').val(1);
  // });
  var price = $(".price-list.price-list--lg sale-price.text-lg").attr(
    "data-price",
  );
  var path = window.location.href;
  $(".cstmTabs .inner-color-div a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
    }
  });
});

window.onload = function () {
  $(".cstmhome-tabs").each(function (i) {
    $(this).addClass("tabsnew" + i);
  });
};

// ============================================================

var pInfScrLoading = false;
var pInfScrDelay = 50;
window.__infScrollLoading = false;

function pInfScrExecute() {
  if (
    $(document).height() - 800 <
    $(document).scrollTop() + $(window).height()
  ) {
    var pInfScrNode = $(".more").last();
    var pInfScrURL = $(".more a").last().attr("href");

    // ❌ stop if already loading or no next page
    if (pInfScrLoading || !pInfScrURL) return;

    $.ajax({
      type: "GET",
      url: pInfScrURL,

      beforeSend: function () {
        pInfScrLoading = true;
        window.__infScrollLoading = true;

        if (!$(".loader-ellips").length) {
          $("#product-list-foot").before(
            '<div class="loader-ellips">' +
              '<span class="loader-ellips__dot"></span>' +
              '<span class="loader-ellips__dot"></span>' +
              '<span class="loader-ellips__dot"></span>' +
              '<span class="loader-ellips__dot"></span>' +
              "</div>",
          );
        }

        pInfScrNode.hide();
      },

      success: function (data) {
        var $data = $(data);

        // 1️⃣ Get new products
        var $newProducts = $data.find("product-list > *");

        // 2️⃣ Get next pagination link
        var $newMore = $data.find(".more").last();

        if ($newProducts.length) {
          // Append products
          $("product-list").append($newProducts);

          // 3️⃣ Replace old ".more" with new one
          if ($newMore.length) {
            $(".more").replaceWith($newMore);
            pInfScrLoading = false;
            window.__infScrollLoading = false;
            $(".loader-ellips").remove();
          } else {
            // ❌ No next page
            $(".loader-ellips").remove();
            $(".more").remove();
            $(window).off("scroll");
          }
        } else {
          // ❌ No products returned
          $(".loader-ellips").remove();
          $(".more").remove();
          $(window).off("scroll");
        }
      },

      error: function () {
        $(".loader-ellips").remove();
        pInfScrLoading = false;
        window.__infScrollLoading = false;
      },

      dataType: "html",
    });
  }
}

$(document).ready(function () {
  $(window).scroll(function () {
    $.doTimeout("scroll", pInfScrDelay, pInfScrExecute);
    if (
      $(document).height() - 800 >
      $(document).scrollTop() + $(window).height()
    ) {
      pInfScrDelay = 50;
    }
  });
  if (window.location.href.indexOf("/products/") > -1) {
    let el = document.querySelector(
      ".shopify-section--main-product .product-info__buy-buttons",
    );
    let element = document.querySelector(
      ".shopify-section--main-product .product-quick-add",
    );
    // if(isInViewport(el)) {
    //   element.classList.remove("is-visible");
    // }
    // $(window).scroll(function(){
    //   if(isInViewport(el)) {
    //     element.classList.remove("is-visible");
    //   }
    // });
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  }
});

function prepareGoKwikBuyNow(button) {
  if (!button || !(button instanceof Element)) return;
  const form = button.closest('form[is="product-form"]');
  if (!(form instanceof HTMLFormElement)) return;

  const parseVariantId = function (value) {
    const parsedValue = parseInt(value, 10);
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
  };

  const getPreferredVariantId = function () {
    const enabledVariantInput = form.querySelector(
      'input[name="id"]:not([disabled])',
    );
    const enabledVariantId = parseVariantId(
      enabledVariantInput && enabledVariantInput.value,
    );
    if (enabledVariantId) return enabledVariantId;

    const localVariantInput = form.querySelector('input[name="id"]');
    const localVariantId = parseVariantId(
      localVariantInput && localVariantInput.value,
    );
    if (localVariantId) return localVariantId;

    if (form.id) {
      const boundVariantInput = document.querySelector(
        '[name="id"][form="' + form.id + '"]',
      );
      const boundVariantId = parseVariantId(
        boundVariantInput && boundVariantInput.value,
      );
      if (boundVariantId) return boundVariantId;
    }

    return null;
  };

  const qtyInput = form.querySelector('input[name="quantity"]');
  if (qtyInput) {
    const qtyValue = parseInt(qtyInput.value, 10);
    const finalQty = Number.isFinite(qtyValue) && qtyValue > 0 ? qtyValue : 1;
    qtyInput.value = String(finalQty);
    qtyInput.setAttribute("value", String(finalQty));
  }

  const preferredVariantId = getPreferredVariantId();
  if (preferredVariantId) {
    let variantInput = form.querySelector('input[name="id"]:not([disabled])');

    if (!variantInput) {
      variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.removeAttribute("disabled");
      } else {
        variantInput = document.createElement("input");
        variantInput.type = "hidden";
        variantInput.name = "id";
        form.appendChild(variantInput);
      }
    }

    variantInput.value = String(preferredVariantId);
    variantInput.setAttribute("value", String(preferredVariantId));
  }

  form.dataset.gokwikSubmit = "1";
}
window.prepareGoKwikBuyNow = prepareGoKwikBuyNow;

// Watches for GoKwik's checkout popup to be dismissed and calls callback once.
function watchGoKwikCloseOnce(callback) {
  var fired = false;
  var gkElements = [];
  var popupDetected = false;

  function fire() {
    if (fired) return;
    fired = true;
    obs.disconnect();
    window.removeEventListener("message", onMsg);
    GK_DISMISS_EVENTS.forEach(function (name) {
      window.removeEventListener(name, fire);
    });
    clearTimeout(safetyTimer);
    callback();
  }

  var GK_SELECTORS = [
    'iframe[src*="gokwik"]',
    'iframe[src*="kwik.co"]',
    'iframe[src*="kwik"]',
    ".gokwik-overlay",
    ".gk-overlay",
    "#gk-overlay",
    "#gokwik-overlay",
    ".gokwik-backdrop",
    "#gokwik-backdrop",
    ".gokwik-popup",
    "#gokwik-popup",
  ];

  var GK_DISMISS_EVENTS = [
    "gokwik:close",
    "gokwikClose",
    "gokwik:dismiss",
    "gokwikDismiss",
    "kwik:close",
    "kwikClose",
  ];

  function findGkElements() {
    var found = [];
    GK_SELECTORS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          if (found.indexOf(el) === -1) found.push(el);
        });
      } catch (e) {}
    });
    return found;
  }

  var obs = new MutationObserver(function () {
    var current = findGkElements();
    if (current.length > 0 && !popupDetected) {
      popupDetected = true;
      gkElements = current;
    }
    if (popupDetected) {
      var allGone = gkElements.every(function (el) {
        return !document.body.contains(el);
      });
      if (allGone) fire();
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });

  // Listen for postMessage events from GoKwik's iframe
  function onMsg(event) {
    if (!event.data) return;
    var str =
      typeof event.data === "string" ? event.data : JSON.stringify(event.data);
    var fromGk =
      event.origin && /gokwik|kwik\.co/i.test(event.origin);
    var isClose = /close|dismiss|cancel|abort|back/i.test(str);
    if (fromGk || (isClose && popupDetected)) fire();
  }
  window.addEventListener("message", onMsg);

  // Listen for any GoKwik custom events
  GK_DISMISS_EVENTS.forEach(function (name) {
    window.addEventListener(name, fire, { once: true });
  });

  // Safety cleanup: if GoKwik popup was never detected after 10 s, give up
  var safetyTimer = setTimeout(function () {
    if (!popupDetected) {
      obs.disconnect();
      window.removeEventListener("message", onMsg);
      GK_DISMISS_EVENTS.forEach(function (name) {
        window.removeEventListener(name, fire);
      });
    }
  }, 10000);
}

// Restores the Shopify cart to a previously saved snapshot.
async function restoreCartFromSnapshot(snapshot) {
  if (!snapshot) return;
  var snapshotItems = Array.isArray(snapshot.items) ? snapshot.items : [];

  try {
    // Brief pause so GoKwik finishes its own teardown first.
    await new Promise(function (r) { setTimeout(r, 400); });

    // Clear whatever GoKwik left in the cart.
    await fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" });

    // Re-add all items that were in the cart before Buy Now.
    if (snapshotItems.length > 0) {
      var payload = snapshotItems.map(function (item) {
        var entry = { id: item.variant_id, quantity: item.quantity };
        if (item.properties && Object.keys(item.properties).length > 0) {
          entry.properties = item.properties;
        }
        if (
          item.selling_plan_allocation &&
          item.selling_plan_allocation.selling_plan
        ) {
          entry.selling_plan = item.selling_plan_allocation.selling_plan.id;
        }
        return entry;
      });
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: payload }),
      });
    }

    // Refresh the cart drawer UI.
    var sectionRes = await fetch("/?section_id=cart-drawer", {
      credentials: "same-origin",
    });
    if (sectionRes.ok) {
      var html = await sectionRes.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var cartSection = document.querySelector("#shopify-section-cart-drawer");
      var newSection = doc.querySelector("#shopify-section-cart-drawer");
      if (cartSection && newSection) {
        var curDrawer = cartSection.querySelector("cart-drawer");
        var newDrawer = newSection.querySelector("cart-drawer");
        if (curDrawer && newDrawer) {
          curDrawer.innerHTML = newDrawer.innerHTML;
        } else {
          cartSection.innerHTML = newSection.innerHTML;
        }
      }
    }

    // Refresh the cart item count in the header.
    var countRes = await fetch("/cart.js", { credentials: "same-origin" });
    if (countRes.ok) {
      var cart = await countRes.json();
      document.querySelectorAll("cart-count").forEach(function (counter) {
        counter.textContent = String(cart.item_count || 0);
        if (counter.classList.contains("count-bubble")) {
          counter.classList.toggle("opacity-0", !cart.item_count);
        }
      });
    }
  } catch (e) {
    // Silent fail — cart will sync on the next page interaction.
  }
}

async function triggerSafeGoKwikBuyNow(button) {
  if (!button || !(button instanceof Element)) return;
  if (button.disabled || button.classList.contains("gokwik-disabled")) return;

  const parsePositiveInt = function (value) {
    const parsedValue = parseInt(value, 10);
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
  };

  const form =
    button.closest('form[is="product-form"]') || button.closest("form");
  let formSelector = false;

  if (form instanceof HTMLFormElement) {
    if (!form.id) {
      form.id = "gokwik-product-form-" + Date.now();
    }
    formSelector = "#" + form.id;
  }

  const getVariantId = function () {
    if (!(form instanceof HTMLFormElement)) return null;

    const enabledVariantInput = form.querySelector(
      'input[name="id"]:not([disabled])',
    );
    const enabledVariantId = parsePositiveInt(
      enabledVariantInput && enabledVariantInput.value,
    );
    if (enabledVariantId) return enabledVariantId;

    const localVariantInput = form.querySelector('input[name="id"]');
    const localVariantId = parsePositiveInt(
      localVariantInput && localVariantInput.value,
    );
    if (localVariantId) return localVariantId;

    if (form.id) {
      const boundVariantInput = document.querySelector(
        '[name="id"][form="' + form.id + '"]',
      );
      const boundVariantId = parsePositiveInt(
        boundVariantInput && boundVariantInput.value,
      );
      if (boundVariantId) return boundVariantId;
    }

    return null;
  };

  const getQuantity = function () {
    if (!(form instanceof HTMLFormElement)) return 1;

    if (button.closest(".product-quick-add__variant")) {
      return 1;
    }

    const readQty = function (input) {
      if (!input) return null;
      return (
        parsePositiveInt(input.value) ||
        parsePositiveInt(input.getAttribute("value"))
      );
    };

    const isVisible = function (el) {
      if (!el) return false;
      if (el.hidden) return false;
      const style = window.getComputedStyle(el);
      if (style.display === "none" || style.visibility === "hidden")
        return false;
      return Boolean(el.offsetParent || el.getClientRects().length);
    };

    const visibleFirst = function (inputs) {
      for (const input of inputs) {
        if (!isVisible(input)) continue;
        const qty = readQty(input);
        if (qty) return qty;
      }

      for (const input of inputs) {
        const qty = readQty(input);
        if (qty) return qty;
      }

      return null;
    };

    const candidates = [];

    if (form.id) {
      const formQuantityInput = document.getElementById(form.id + "-quantity");
      if (formQuantityInput) candidates.push(formQuantityInput);

      const formOverlayInput = document.getElementById(
        form.id + "-overlay-quantity",
      );
      if (formOverlayInput) candidates.push(formOverlayInput);

      const boundQtyInputs = document.querySelectorAll(
        '[name="quantity"][form="' +
          form.id +
          '"], [name="overlay_quantity"][form="' +
          form.id +
          '"]',
      );
      boundQtyInputs.forEach(function (input) {
        candidates.push(input);
      });

      const overlayByForm = document.querySelector(
        '#additionalContent input[name="overlay_quantity"][data-form-id="' +
          form.id +
          '"]',
      );
      if (overlayByForm) candidates.push(overlayByForm);
    }

    const localQtyInputs = form.querySelectorAll(
      'input[name="quantity"], input[name="overlay_quantity"]',
    );
    localQtyInputs.forEach(function (input) {
      candidates.push(input);
    });

    const nearestQtyInputs = document.querySelectorAll(
      '.product-info__quantity-selector input[name="quantity"], #additionalContent input[name="overlay_quantity"], #homeatcc',
    );
    nearestQtyInputs.forEach(function (input) {
      candidates.push(input);
    });

    const qty = visibleFirst(candidates);
    return qty || 1;
  };

  const variantId = getVariantId();
  const quantity = getQuantity();

  // Save cart snapshot before GoKwik clears it; restored on the next Add to Cart.
  try {
    const snapRes = await fetch("/cart.js", { credentials: "same-origin" });
    if (snapRes.ok) window.__gkCartSnapshot = await snapRes.json();
  } catch (e) {}

  // Prefer explicit-item flow to avoid selector parsing issues in GoKwik.
  if (variantId && typeof window.gokwikBuyNowClickFn === "function") {
    window.gokwikBuyNowClickFn(button, false, [
      { id: String(variantId), quantity: quantity },
    ]);
    return;
  }

  if (typeof window.onBuyNowClick === "function") {
    window.onBuyNowClick(button, formSelector);
  }
}
window.triggerSafeGoKwikBuyNow = triggerSafeGoKwikBuyNow;

document.addEventListener("variant:change", function (event) {
  if (!event.detail || !event.detail.variant) return;
  const variant = event.detail.variant;
  const variantId = variant.id;
  const variantInStock = Boolean(
    variant &&
    variant.available &&
    (variant.inventory_management !== "shopify" ||
      variant.inventory_policy === "continue" ||
      Number(variant.inventory_quantity || 0) > 0),
  );

  // Compute the effective max quantity for this variant.
  const isTracked = variant.inventory_management === "shopify";
  const canOversell = variant.inventory_policy === "continue";
  const stockQty = Number(variant.inventory_quantity || 0);
  const effectiveMax =
    isTracked && !canOversell && stockQty > 0 ? stockQty : 999;

  document.querySelectorAll('form[is="product-form"]').forEach(function (form) {
    const idInput =
      form.querySelector('input[name="id"]:not([disabled])') ||
      form.querySelector('input[name="id"]');
    if (idInput && variantId) {
      idInput.value = String(variantId);
      idInput.setAttribute("value", String(variantId));
    }

    const buyNowButton = form.querySelector("#gokwik-buy-now");
    if (buyNowButton) {
      buyNowButton.disabled = !variantInStock;
      buyNowButton.classList.toggle("disabled", !variantInStock);
      buyNowButton.classList.toggle("gokwik-disabled", !variantInStock);
      buyNowButton.setAttribute(
        "aria-disabled",
        variantInStock ? "false" : "true",
      );
    }
  });

  // Update quantity selector max so UI prevents over-ordering.
  document
    .querySelectorAll(
      ".shopify-section--main-product quantity-selector, .product-info quantity-selector",
    )
    .forEach(function (qs) {
      if (typeof qs.updateInventory === "function") {
        qs.updateInventory(effectiveMax);
      } else {
        qs.setAttribute("max", String(effectiveMax));
        const input = qs.querySelector('input[name="quantity"]');
        if (input) {
          input.setAttribute("max", String(effectiveMax));
          const cur = parseInt(input.value, 10) || 1;
          if (cur > effectiveMax) input.value = String(effectiveMax);
        }
      }
    });
});

// Lock the page scroll while focus lives in the site search UI (query field or its dropdown /
// drawer / SearchTap surface). Patching window.scroll* cannot cover every path (iOS, SearchTap
// timers, minified code); the same "fixed body" pattern as the cart drawer stops the document
// from moving under the user while they type.
(function () {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  var Q_INPUT = "input[name=\"q\"]";
  var searchRegionSelector =
    ".st-search-bar, .st-mobile-search-overlay, search-drawer, #search-drawer, #searchModal, #searchModalContainer";
  var BODY_CLASS = "cstn-search-scroll-locked";
  var lockedY = 0;
  var isLocked = false;

  function isFocusInsideSearchShell(el) {
    if (!el) return false;
    if (el.matches && el.matches(Q_INPUT)) return true;
    if (el.closest && el.closest(searchRegionSelector)) return true;
    return false;
  }

  function isOtherDrawerLockingBody() {
    if (!document.body) return false;
    if (document.body.classList.contains("drawer-open")) return true;
    var pos = window.getComputedStyle(document.body).position;
    if (pos === "fixed" && !document.body.classList.contains(BODY_CLASS)) return true;
    return false;
  }

  function lock() {
    if (isLocked) return;
    if (isOtherDrawerLockingBody()) return;
    lockedY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add(BODY_CLASS);
    document.body.style.position = "fixed";
    document.body.style.top = -lockedY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
    isLocked = true;
  }

  function unlock() {
    if (!isLocked) return;
    document.body.classList.remove(BODY_CLASS);
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    window.scrollTo(0, lockedY);
    isLocked = false;
  }

  function syncSearchScrollLock() {
    requestAnimationFrame(function () {
      var a = document.activeElement;
      if (isFocusInsideSearchShell(a)) {
        lock();
      } else {
        unlock();
      }
    });
  }

  document.addEventListener("focusin", function () {
    syncSearchScrollLock();
  }, true);

  document.addEventListener("focusout", function () {
    syncSearchScrollLock();
  }, true);

  window.addEventListener("load", function () {
    syncSearchScrollLock();
  });
})();

// Force cart drawer behavior instead of redirecting to /cart page.
(function () {
  const CART_DRAWER_SELECTOR = "#cart-drawer";
  const CART_SECTION_SELECTOR = "#shopify-section-cart-drawer";
  const CART_DRAWER_HISTORY_KEY = "__stCartDrawerOpen";
  const CART_DRAWER_SKIP_BACK_KEY = "__stCartDrawerSkipBackOnce";
  let lastAtcSubmitQty = null;
  let lastAtcSubmitAt = 0;
  let lastAtcSubmitter = null;
  let lastAtcSubmitterAt = 0;
  let lockedScrollY = 0;
  let isBodyScrollLocked = false;

  function getVisibleRuntimeQty() {
    const isVisible = function (el) {
      if (!el) return false;
      if (el.hidden) return false;
      const style = window.getComputedStyle(el);
      if (style.display === "none" || style.visibility === "hidden")
        return false;
      return Boolean(el.offsetParent || el.getClientRects().length);
    };

    const selectors = [
      "#homeatcc",
      '#additionalContent input[name="overlay_quantity"]',
      '.shopify-section--main-product input[name="quantity"]',
      'input[id$="-sticky-quantity"]',
      '.product-info__quantity-selector input[name="quantity"]',
      'input[name="overlay_quantity"]',
      'input[name="quantity"]',
    ];

    let maxQty = null;

    for (const selector of selectors) {
      const nodes = document.querySelectorAll(selector);
      for (const input of nodes) {
        if (!isVisible(input)) continue;
        const qty = parseInt(input.value || input.getAttribute("value"), 10);
        if (Number.isFinite(qty) && qty > 0) {
          maxQty = maxQty === null ? qty : Math.max(maxQty, qty);
        }
      }
    }

    return maxQty;
  }

  function getRecentSubmitterForForm(form) {
    if (!form || !lastAtcSubmitter) return null;
    if (Date.now() - lastAtcSubmitterAt > 3000) return null;
    if (!lastAtcSubmitter.isConnected) return null;

    const directFormMatch = lastAtcSubmitter.form === form;
    const boundFormMatch =
      form.id &&
      lastAtcSubmitter.hasAttribute &&
      lastAtcSubmitter.getAttribute("form") === form.id;

    return directFormMatch || boundFormMatch ? lastAtcSubmitter : null;
  }

  function isCartPage() {
    return /^\/cart(?:\/|$)/.test(window.location.pathname);
  }

  function isCartCheckoutFormAction(action) {
    const normalizedAction = String(action || "")
      .split("?")[0]
      .toLowerCase()
      .replace(/\/+$/, "");
    return normalizedAction.endsWith("/cart");
  }

  function getCurrentHistoryState() {
    return window.history && window.history.state &&
      typeof window.history.state === "object"
      ? window.history.state
      : {};
  }

  function hasCartDrawerHistoryState(state) {
    return Boolean(state && state[CART_DRAWER_HISTORY_KEY]);
  }

  function getHistoryStateWithoutDrawerFlags(state) {
    const currentState =
      state && typeof state === "object" ? Object.assign({}, state) : {};
    delete currentState[CART_DRAWER_HISTORY_KEY];
    delete currentState[CART_DRAWER_SKIP_BACK_KEY];
    return currentState;
  }

  function ensureCartDrawerHistoryState() {
    if (isCartPage()) return;
    if (!window.history || typeof window.history.pushState !== "function") return;
    if (hasCartDrawerHistoryState(getCurrentHistoryState())) return;

    try {
      window.history.pushState(
        Object.assign({}, getCurrentHistoryState(), {
          [CART_DRAWER_HISTORY_KEY]: true,
        }),
        "",
        window.location.href,
      );
    } catch (error) {}
  }

  function markDrawerClosedViaUi() {
    if (isCartPage()) return;
    if (!window.history || typeof window.history.replaceState !== "function") return;

    try {
      window.history.replaceState(
        Object.assign({}, getHistoryStateWithoutDrawerFlags(getCurrentHistoryState()), {
          [CART_DRAWER_SKIP_BACK_KEY]: true,
        }),
        "",
        window.location.href,
      );
    } catch (error) {}
  }

  function lockBodyScroll() {
    if (isBodyScrollLocked) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = "fixed";
    document.body.style.top = "-" + lockedScrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
    document.body.classList.add("drawer-open");
    isBodyScrollLocked = true;
  }

  function unlockBodyScroll() {
    if (!isBodyScrollLocked) return;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    document.body.classList.remove("drawer-open");
    window.scrollTo(0, lockedScrollY);
    isBodyScrollLocked = false;
  }

  function openCartDrawer() {
    const drawer = document.querySelector(CART_DRAWER_SELECTOR);
    if (!drawer) return;

    ensureCartDrawerHistoryState();

    // Prefer the theme's own trigger path so any internal drawer logic runs.
    const nativeTrigger = document.querySelector(
      '[aria-controls="cart-drawer"]',
    );
    if (nativeTrigger && !drawer.hasAttribute("open")) {
      nativeTrigger.click();
    }

    if (typeof drawer.show === "function") {
      drawer.show();
    } else {
      drawer.setAttribute("open", "");
    }
    lockBodyScroll();

    // Theme overlay logic assumes a left drawer in some cases. On this theme the cart
    // opens from right, so ensure overlay stays outside the drawer hit area.
    normalizeCartDrawerOverlay(drawer);
    requestAnimationFrame(function () {
      normalizeCartDrawerOverlay(drawer);
      setTimeout(function () {
        normalizeCartDrawerOverlay(drawer);
      }, 120);
    });
  }

  function closeCartDrawer(options) {
    const closeOptions = options || {};
    if (closeOptions.fromUi) {
      markDrawerClosedViaUi();
    }
    forceCloseCartDrawer();
  }

  function forceCloseCartDrawer() {
    const drawer = document.querySelector(CART_DRAWER_SELECTOR);
    if (!drawer) return;

    if (typeof drawer.hide === "function") {
      drawer.hide();
      unlockBodyScroll();
      return;
    }

    drawer.removeAttribute("open");
    unlockBodyScroll();
  }

  function normalizeCartDrawerOverlay(drawer) {
    if (!drawer || !drawer.hasAttribute("open")) return;

    const overlay = document.querySelector("body > .drawer-overlay");
    if (!overlay) return;

    const rect = drawer.getBoundingClientRect();
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth || 0;
    const drawerWidth = Math.max(Math.round(rect.width || 0), 0);
    if (!drawerWidth || !viewportWidth) return;

    const opensFromRight =
      drawer.getAttribute("open-from") === "right" ||
      rect.left > viewportWidth / 2;

    if (opensFromRight) {
      const rightInset = Math.max(Math.round(viewportWidth - rect.left), 0);
      overlay.style.left = "0";
      overlay.style.right = rightInset + "px";
    } else {
      const leftInset = Math.max(Math.round(rect.right), 0);
      overlay.style.left = leftInset + "px";
      overlay.style.right = "0";
    }

    overlay.style.zIndex = "1";
    overlay.style.pointerEvents = "auto";
    drawer.style.zIndex = "2";
  }

  if (typeof window.safeGoKwikCheckout !== "function") {
    window.safeGoKwikCheckout = function (btn) {
      const checkoutButton =
        (btn && btn instanceof Element ? btn : null) ||
        document.querySelector(".gokwik-checkout button");

      if (checkoutButton && typeof window.onCheckoutClick === "function") {
        window.onCheckoutClick(checkoutButton);
        return;
      }

      window.location.href = "/checkout";
    };
  }

  function triggerCartGoKwikCheckout(preferredButton) {
    const checkoutButton =
      (preferredButton && preferredButton instanceof Element
        ? preferredButton
        : null) || document.querySelector(".gokwik-checkout button");

    if (checkoutButton && typeof window.safeGoKwikCheckout === "function") {
      window.safeGoKwikCheckout(checkoutButton);
      return true;
    }

    if (checkoutButton && typeof window.onCheckoutClick === "function") {
      window.onCheckoutClick(checkoutButton);
      return true;
    }

    return false;
  }

  function updateCartCounters(itemCount) {
    document.querySelectorAll("cart-count").forEach(function (counter) {
      counter.textContent = String(itemCount);

      if (counter.classList.contains("count-bubble")) {
        counter.classList.toggle("opacity-0", itemCount === 0);
      }
    });
  }

  function getPreferredFormVariantId(form) {
    if (!form) return null;

    const parseVariant = function (value) {
      const n = parseInt(value, 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    };

    const enabledVariantInput = form.querySelector(
      'input[name="id"]:not([disabled])',
    );
    const enabledVariant = parseVariant(
      enabledVariantInput && enabledVariantInput.value,
    );
    if (enabledVariant) return enabledVariant;

    const anyLocalVariantInput = form.querySelector('input[name="id"]');
    const anyLocalVariant = parseVariant(
      anyLocalVariantInput && anyLocalVariantInput.value,
    );
    if (anyLocalVariant) return anyLocalVariant;

    if (form.id) {
      const boundVariantInput = document.querySelector(
        '[name="id"][form="' + form.id + '"]',
      );
      const boundVariant = parseVariant(
        boundVariantInput && boundVariantInput.value,
      );
      if (boundVariant) return boundVariant;
    }

    return null;
  }

  function updateMinusButtonState(root) {
    (root || document)
      .querySelectorAll(".cart-button")
      .forEach(function (wrapper) {
        const input = wrapper.querySelector(".quantity-input");
        const minus = wrapper.querySelector(".cart-mini");

        if (!input || !minus) return;

        const qty = parseInt(input.value, 10) || 1;
        minus.disabled = qty <= 1;
      });
  }

  function getPreferredFormQuantity(form, submitter) {
    if (!form) return 1;

    const parseQty = function (value) {
      const n = parseInt(value, 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    };

    const readInputQty = function (input) {
      if (!input) return null;
      // Some legacy scripts mutate only the value attribute via setAttribute().
      return parseQty(input.value) || parseQty(input.getAttribute("value"));
    };

    const isVisible = function (el) {
      if (!el) return false;
      if (el.hidden) return false;
      const style = window.getComputedStyle(el);
      if (style.display === "none" || style.visibility === "hidden")
        return false;
      return Boolean(el.offsetParent || el.getClientRects().length);
    };

    const getScopedBoundQty = function (scope) {
      if (!scope || !form.id) return null;

      const scopedInputs = scope.querySelectorAll(
        '[name="quantity"][form="' + form.id + '"]',
      );

      for (const input of scopedInputs) {
        if (!isVisible(input)) continue;
        const qty = readInputQty(input);
        if (qty) return qty;
      }

      for (const input of scopedInputs) {
        const qty = readInputQty(input);
        if (qty) return qty;
      }

      return null;
    };

    const getContextQty = function (scope) {
      if (!scope) return null;

      const candidates = scope.querySelectorAll(
        'input[name="quantity"], input[name="overlay_quantity"]',
      );

      for (const input of candidates) {
        if (!isVisible(input)) continue;
        const qty = readInputQty(input);
        if (qty) return qty;
      }

      for (const input of candidates) {
        const qty = readInputQty(input);
        if (qty) return qty;
      }

      return null;
    };

    // Legacy popup ATC uses #homeatcc as visible quantity and #homeatc hidden in form.
    if (form.id === "atcForm" || form.querySelector("#homeatc")) {
      const popupQty = readInputQty(document.getElementById("homeatcc"));
      if (popupQty) return popupQty;
    }

    const isQuickAddSubmit = Boolean(
      submitter && submitter.closest("product-quick-add"),
    );

    // Product quick-add CTA should always add exactly 1.
    if (isQuickAddSubmit) {
      return 1;
    }

    // Prefer quantity input in the same visible UI context as the clicked submitter.
    if (submitter) {
      const directContextQty = getContextQty(
        submitter.closest("product-quick-add") ||
          submitter.closest(".product-info") ||
          submitter.closest("#additionalContent") ||
          submitter.closest("#popup") ||
          submitter.closest(".shopify-section--main-product"),
      );
      if (directContextQty) return directContextQty;

      const scopedContexts = [
        submitter.closest("product-quick-add"),
        submitter.closest(".product-info"),
        submitter.closest("#additionalContent"),
        submitter.closest("#popup"),
        submitter.closest(".shopify-section--main-product"),
      ];

      for (const scope of scopedContexts) {
        const scopedQty = getScopedBoundQty(scope);
        if (scopedQty) return scopedQty;
      }
    }

    // For regular product page ATC, prefer the main quantity field by deterministic id.
    // This avoids accidentally reading sticky quick-add's default value (1).
    const mainQtyInput = form.id
      ? document.getElementById(form.id + "-quantity")
      : null;
    const mainVisibleQty = isVisible(mainQtyInput)
      ? readInputQty(mainQtyInput)
      : null;
    if (mainVisibleQty) return mainVisibleQty;
    const mainFallbackQty = readInputQty(mainQtyInput);
    if (mainFallbackQty) return mainFallbackQty;

    // Otherwise use visible enabled quantity fields bound to the form.
    const boundSelector =
      '[name="quantity"]:not([disabled])[form="' + form.id + '"]';
    const formSelector = '[name="quantity"]:not([disabled])';
    const localCandidates = Array.from(form.querySelectorAll(formSelector));
    const boundCandidates = Array.from(
      document.querySelectorAll(boundSelector),
    );
    const candidates = localCandidates.concat(boundCandidates);

    for (const input of candidates) {
      if (!isVisible(input)) continue;
      const qty = readInputQty(input);
      if (qty) return qty;
    }

    for (const input of candidates) {
      const qty = readInputQty(input);
      if (qty) return qty;
    }

    return 1;
  }

  async function refreshCartDrawerFromSection() {
    const cartSection = document.querySelector(CART_SECTION_SELECTOR);
    if (!cartSection) return;

    const sectionUrls = [
      "/?section_id=cart-drawer",
      "/cart?section_id=cart-drawer",
    ];
    let updatedSection = null;

    for (const sectionUrl of sectionUrls) {
      const response = await fetch(sectionUrl, { credentials: "same-origin" });
      if (!response.ok) continue;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      updatedSection = doc.querySelector(CART_SECTION_SELECTOR);
      if (updatedSection) break;
    }

    if (updatedSection) {
      const currentDrawer = cartSection.querySelector("cart-drawer");
      const newDrawer = updatedSection.querySelector("cart-drawer");

      if (currentDrawer && newDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      } else {
        cartSection.innerHTML = updatedSection.innerHTML;
      }
    }
  }

  async function syncCartAfterChange(keepDrawerOpen) {
    const drawer = document.querySelector(CART_DRAWER_SELECTOR);
    const shouldKeepOpen =
      Boolean(keepDrawerOpen) || Boolean(drawer && drawer.hasAttribute("open"));

    await Promise.all([refreshCartDrawerFromSection(), syncCartMeta()]);

    const newDrawer = document.querySelector(CART_DRAWER_SELECTOR);
    updateMinusButtonState(newDrawer);

    if (shouldKeepOpen) {
      openCartDrawer();
    }
  }

  async function syncCartMeta() {
    const response = await fetch("/cart.js", { credentials: "same-origin" });
    if (!response.ok) {
      throw new Error("Unable to fetch cart details");
    }

    const cart = await response.json();
    updateCartCounters(cart.item_count || 0);
  }

  let isRefreshingCartUi = false;

  async function refreshCartUiFromServer(options) {
    const refreshOptions = options || {};
    if (isRefreshingCartUi) return;

    isRefreshingCartUi = true;
    try {
      await Promise.all([refreshCartDrawerFromSection(), syncCartMeta()]);

      const drawer = document.querySelector(CART_DRAWER_SELECTOR);
      updateMinusButtonState(drawer);

      if (refreshOptions.keepDrawerOpen && drawer && drawer.hasAttribute("open")) {
        normalizeCartDrawerOverlay(drawer);
      }
    } finally {
      isRefreshingCartUi = false;
    }
  }

  function showInventoryShortageMessage(shortage, available) {
    const safeShortage = Math.max(parseInt(shortage, 10) || 0, 0);
    const safeAvailable = Math.max(parseInt(available, 10) || 0, 0);
    if (safeShortage <= 0) return;

    const id = "inventory-shortage-toast";
    let toast = document.getElementById(id);

    if (!toast) {
      toast = document.createElement("div");
      toast.id = id;
      toast.style.position = "fixed";
      toast.style.left = "50%";
      toast.style.bottom = "24px";
      toast.style.transform = "translateX(-50%)";
      toast.style.zIndex = "99999";
      toast.style.maxWidth = "min(92vw, 560px)";
      toast.style.width = "max-content";
      toast.style.padding = "10px 14px";
      toast.style.borderRadius = "10px";
      toast.style.background = "rgba(20,20,20,0.96)";
      toast.style.color = "#fff";
      toast.style.fontSize = "14px";
      toast.style.lineHeight = "1.4";
      toast.style.boxShadow = "0 8px 24px rgba(0,0,0,0.28)";
      toast.style.opacity = "0";
      toast.style.transition = "opacity .2s ease";
      document.body.appendChild(toast);
    }

    const message =
      safeAvailable <= 0
        ? "This item is out of stock."
        : "Only " + safeAvailable + " available.";
    toast.textContent = message;
    toast.style.opacity = "1";

    if (toast._hideTimer) {
      window.clearTimeout(toast._hideTimer);
    }
    toast._hideTimer = window.setTimeout(function () {
      toast.style.opacity = "0";
    }, 2600);
  }

  function cloneFormData(formData) {
    const cloned = new FormData();
    for (const pair of formData.entries()) {
      cloned.append(pair[0], pair[1]);
    }
    return cloned;
  }

  function normalizePropertiesObject(properties) {
    const out = {};
    if (!properties || typeof properties !== "object") return out;

    Object.keys(properties).forEach(function (key) {
      const value = properties[key];
      if (value === null || value === undefined) return;

      const normalizedKey = String(key).trim();
      const normalizedValue = String(value).trim();
      if (!normalizedKey || !normalizedValue) return;

      out[normalizedKey] = normalizedValue;
    });

    return out;
  }

  function getPropertiesFromFormData(formData) {
    const props = {};

    for (const pair of formData.entries()) {
      const key = pair[0];
      const value = pair[1];
      const match = /^properties\[(.*)\]$/.exec(String(key));
      if (!match) continue;

      const propName = (match[1] || "").trim();
      if (!propName) continue;

      const propValue =
        typeof value === "string" ? value.trim() : String(value || "").trim();
      if (!propValue) continue;

      props[propName] = propValue;
    }

    return props;
  }

  function areSameProperties(a, b) {
    const aKeys = Object.keys(a || {});
    const bKeys = Object.keys(b || {});
    if (aKeys.length !== bKeys.length) return false;

    for (const key of aKeys) {
      if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
      if (String(a[key]) !== String(b[key])) return false;
    }

    return true;
  }

  function findMatchingCartLine(cart, variantId, sellingPlan, properties) {
    if (!cart || !Array.isArray(cart.items)) return null;

    for (const item of cart.items) {
      if (String(item.variant_id) !== String(variantId)) continue;

      const itemSellingPlan =
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan_id
          ? String(item.selling_plan_allocation.selling_plan_id)
          : null;
      if (String(itemSellingPlan || "") !== String(sellingPlan || "")) continue;

      const itemProps = normalizePropertiesObject(item.properties || {});
      if (!areSameProperties(itemProps, properties)) continue;

      return item;
    }

    return null;
  }

  function getCartLineQuantity(cart, variantId, sellingPlan, properties) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      if (String(item.variant_id) !== String(variantId)) return total;
      return total + (parseInt(item.quantity, 10) || 0);
    }, 0);
  }

  async function addProductAndPreserveExistingQuantity(formData) {
    const requestAdd = async function (payload) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: payload,
      });
    };

    const toPositiveInt = function (value, fallback) {
      const parsed = parseInt(value, 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    };

    const variantId = toPositiveInt(formData.get("id"), null);
    const requestedQty = toPositiveInt(formData.get("quantity"), 1);
    const sellingPlanRaw = formData.get("selling_plan");
    const sellingPlan =
      sellingPlanRaw === null ||
      sellingPlanRaw === undefined ||
      sellingPlanRaw === ""
        ? null
        : String(sellingPlanRaw);
    const properties = getPropertiesFromFormData(formData);

    let addResponse = await requestAdd(formData);
    if (addResponse.ok) return;

    let addErrorPayload = null;
    try {
      addErrorPayload = await addResponse.json();
    } catch (error) {}

    if (addResponse.status !== 422 || !variantId) {
      const genericError = new Error(
        (addErrorPayload &&
          (addErrorPayload.description || addErrorPayload.message)) ||
          "Add to cart failed",
      );
      throw genericError;
    }

    const [cartResponse, variantResponse] = await Promise.all([
      fetch("/cart.js", { credentials: "same-origin" }),
      fetch("/variants/" + variantId + ".js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      }),
    ]);

    if (!cartResponse.ok || !variantResponse.ok) {
      const stockError = new Error("Unable to validate stock");
      stockError.suppressNativeSubmit = true;
      throw stockError;
    }

    const [cart, variantData] = await Promise.all([
      cartResponse.json(),
      variantResponse.json(),
    ]);

    const isInventoryTracked =
      variantData && variantData.inventory_management === "shopify";
    const isOversellingAllowed =
      variantData && String(variantData.inventory_policy || "") === "continue";
    const stockQty = toPositiveInt(
      variantData && variantData.inventory_quantity,
      0,
    );

    if (!isInventoryTracked || isOversellingAllowed) {
      const passthroughError = new Error(
        (addErrorPayload &&
          (addErrorPayload.description || addErrorPayload.message)) ||
          "Add to cart failed",
      );
      throw passthroughError;
    }

    const existingQty = getCartLineQuantity(
      cart,
      variantId,
      sellingPlan,
      properties,
    );
    const availableLeft = Math.max(stockQty - existingQty, 0);
    const allowedQty = Math.min(requestedQty, availableLeft);
    const shortage = Math.max(requestedQty - allowedQty, 0);

    if (shortage > 0) {
      showInventoryShortageMessage(shortage, availableLeft);
    }

    if (allowedQty <= 0) {
      showInventoryShortageMessage(requestedQty, 0);
      const fullyOutError = new Error("Out of stock");
      fullyOutError.suppressNativeSubmit = true;
      throw fullyOutError;
    }

    const retryFormData = cloneFormData(formData);
    retryFormData.set("quantity", String(allowedQty));

    addResponse = await requestAdd(retryFormData);
    if (!addResponse.ok) {
      let retryPayload = null;
      try {
        retryPayload = await addResponse.json();
      } catch (error) {}

      const retryError = new Error(
        (retryPayload && (retryPayload.description || retryPayload.message)) ||
          "Add to cart failed",
      );
      retryError.suppressNativeSubmit = true;
      throw retryError;
    }
  }

  let cartUpdateTimer = null;
  const pendingCartUpdates = {};
  let isSyncingCart = false;

  async function performCartUpdate() {
    if (Object.keys(pendingCartUpdates).length === 0) return;

    const updates = {};
    for (const key in pendingCartUpdates) {
      updates[key] = pendingCartUpdates[key];
      delete pendingCartUpdates[key];
    }

    isSyncingCart = true;
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ updates: updates }),
      });

      if (!response.ok) {
        throw new Error("Cart update failed");
      }

      await syncCartAfterChange(true);
    } catch (error) {
      window.location.reload();
    } finally {
      isSyncingCart = false;
      if (Object.keys(pendingCartUpdates).length > 0) {
        performCartUpdate();
      }
    }
  }

  function queueDrawerLineItemQuantity(input, qty) {
    const key = input.dataset.lineKey;
    if (!key) return;

    input.value = String(qty);
    updateMinusButtonState(input.closest(".cart-button"));

    pendingCartUpdates[key] = qty;

    const lineItem = input.closest("line-item");
    if (lineItem) {
      lineItem.style.opacity = "0.5";
      lineItem.style.pointerEvents = "none";
    }

    if (!isSyncingCart) {
      performCartUpdate();
    }
  }

  async function addDrawerProductToCart(form) {
    const formData = new FormData(form);
    await addProductAndPreserveExistingQuantity(formData);

    openCartDrawer();
    syncCartAfterChange(true).catch(function () {
      window.location.reload();
    });
  }

  document.addEventListener("click", function (event) {
    if (isCartPage()) return;

    const cartDrawer = event.target.closest(CART_DRAWER_SELECTOR);

    if (cartDrawer) {
        const closeBtn = event.target.closest('[is="close-button"]');
        if (closeBtn) {
          event.preventDefault();
          event.stopPropagation();
          closeCartDrawer({ fromUi: true });
          return;
        }

      const plus = event.target.closest(".cart-plus");
      const minus = event.target.closest(".cart-mini");
      const removeLink = event.target.closest(
        'a[href*="/cart/change"], a[href*="quantity=0"]',
      );

      if (plus || minus) {
        const wrapper = event.target.closest(".cart-button");
        const input = wrapper && wrapper.querySelector(".quantity-input");

        if (!input) return;

        event.preventDefault();
        event.stopPropagation();

        const currentQty = parseInt(input.value, 10) || 1;
        let qty = currentQty;
        const max = input.hasAttribute("max")
          ? parseInt(input.getAttribute("max"), 10)
          : null;

        if (plus && max && currentQty >= max) {
          showInventoryShortageMessage(1, max);
          return;
        }
        if (plus) qty += 1;
        if (minus && currentQty > 1) qty -= 1;

        if (qty === currentQty) return;

        queueDrawerLineItemQuantity(input, qty);
        return;
      }

      if (removeLink) {
        const wrapper = removeLink.closest(".line-item");
        const input = wrapper && wrapper.querySelector(".quantity-input");

        if (input) {
          event.preventDefault();
          event.stopPropagation();

          queueDrawerLineItemQuantity(input, 0);
          return;
        }
      }

      const recButton = event.target.closest(
        '.horizontal-product__cta button[type="submit"]',
      );
      if (recButton) {
        event.preventDefault();
        event.stopPropagation();
        const form = recButton.closest("form");
        if (form) {
          addDrawerProductToCart(form).catch(function (error) {
            if (error && error.suppressNativeSubmit) {
              syncCartAfterChange(true).catch(function () {
                window.location.reload();
              });
              return;
            }
            if (form.requestSubmit) {
              form.requestSubmit(recButton);
            } else {
              form.submit();
            }
          });
        }
        return;
      }

      const checkoutIntent = event.target.closest(
        'button[name="checkout"], input[name="checkout"], button.cart__checkout, button[formaction*="/checkout"], a[href="/checkout"], a[href="/cart/checkout"], a[href*="/cart/checkout"]',
      );
      if (checkoutIntent) {
        event.preventDefault();
        event.stopPropagation();

        if (!triggerCartGoKwikCheckout(checkoutIntent)) {
          window.location.href = "/checkout";
        }
        return;
      }
    }

    const trigger = event.target.closest('[aria-controls="cart-drawer"]');
    const cartLink = event.target.closest(
      'a[href="/cart"], a[href="/cart/"], a[href$="/cart"], a[href*="/cart?"]',
    );

    if (!trigger && !cartLink) return;

    event.preventDefault();
    openCartDrawer();
  });

  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key !== "Escape") return;

      const drawer = document.querySelector(CART_DRAWER_SELECTOR);
      if (!drawer || !drawer.hasAttribute("open")) return;

      event.preventDefault();
      event.stopPropagation();
      closeCartDrawer();
    },
    true,
  );

  // Mobile tap reliability for cart drawer close icon.
  document.addEventListener(
    "touchend",
    function (event) {
      const closeBtn = event.target.closest(
        CART_DRAWER_SELECTOR + ' [is="close-button"]',
      );
      if (!closeBtn) return;

      event.preventDefault();
      event.stopPropagation();
      closeCartDrawer({ fromUi: true });
    },
    { capture: true, passive: false },
  );

  document.addEventListener(
    "dialog:after-hide",
    function (event) {
      const target = event && event.target;
      if (!target || !(target instanceof Element)) return;
      if (target.matches(CART_DRAWER_SELECTOR)) {
        unlockBodyScroll();
      }
    },
    true,
  );

  window.addEventListener("popstate", function (event) {
    const state =
      event && event.state && typeof event.state === "object" ? event.state : {};
    const drawer = document.querySelector(CART_DRAWER_SELECTOR);
    if (state[CART_DRAWER_SKIP_BACK_KEY]) {
      try {
        window.history.replaceState(
          getHistoryStateWithoutDrawerFlags(state),
          "",
          window.location.href,
        );
      } catch (error) {}
      return;
    }

    if (!drawer || !drawer.hasAttribute("open")) return;

    forceCloseCartDrawer();
  });

  window.addEventListener("pageshow", function () {
    refreshCartUiFromServer({ keepDrawerOpen: true }).catch(function () {});
  });

  // Run in capture phase so quantity is corrected before any theme/app submit handler reads the form.
  document.addEventListener(
    "click",
    function (event) {
      const submitControl = event.target.closest(
        'button[type="submit"], input[type="submit"], button#gokwik-buy-now',
      );
      if (!submitControl) return;

      const form =
        submitControl.form ||
        (submitControl.getAttribute("form")
          ? document.getElementById(submitControl.getAttribute("form"))
          : null);
      if (!(form instanceof HTMLFormElement)) return;

      const formAction = (form.getAttribute("action") || "").toLowerCase();
      const isAddToCartForm =
        formAction.includes("/cart/add") || formAction.endsWith("cart/add");
      if (!isAddToCartForm) return;

      if (submitControl.id === "gokwik-buy-now") {
        form.dataset.gokwikSubmit = "1";
        window.setTimeout(function () {
          if (form.dataset.gokwikSubmit === "1") {
            form.dataset.gokwikSubmit = "0";
          }
        }, 3000);
      }

      lastAtcSubmitter = submitControl;
      lastAtcSubmitterAt = Date.now();
    },
    true,
  );

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const submitter = event.submitter || getRecentSubmitterForForm(form);
      const isCheckoutSubmit =
        Boolean(
          submitter &&
          (submitter.name === "checkout" ||
            submitter.classList.contains("cart__checkout") ||
            (submitter.formAction &&
              submitter.formAction.includes("/checkout"))),
        ) ||
        (isCartCheckoutFormAction(form.getAttribute("action")) &&
          form.querySelector('[name="checkout"]'));

      if (!isCheckoutSubmit) return;

      event.preventDefault();
      event.stopPropagation();

      if (!triggerCartGoKwikCheckout(submitter)) {
        window.location.href = "/checkout";
      }
    },
    true,
  );

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const submitter = event.submitter || getRecentSubmitterForForm(form);

      const formAction = (form.getAttribute("action") || "").toLowerCase();
      const isAddToCartForm =
        formAction.includes("/cart/add") || formAction.endsWith("cart/add");
      if (!isAddToCartForm) return;

      if (
        form.dataset.gokwikSubmit === "1" ||
        (submitter &&
          (submitter.name === "checkout" ||
            (submitter.formAction &&
              submitter.formAction.includes("/checkout")) ||
            submitter.id === "gokwik-buy-now"))
      ) {
        return;
      }

      const preferredQty = getPreferredFormQuantity(form, submitter || null);
      const qtyString = String(preferredQty);
      lastAtcSubmitQty = qtyString;
      lastAtcSubmitAt = Date.now();

      const inlineQtyField = form.querySelector('[name="quantity"]');
      if (inlineQtyField) {
        inlineQtyField.value = qtyString;
        inlineQtyField.setAttribute("value", qtyString);
      }

      if (form.id) {
        const boundQtyFields = document.querySelectorAll(
          '[name="quantity"][form="' + form.id + '"]',
        );
        boundQtyFields.forEach(function (input) {
          input.value = qtyString;
          input.setAttribute("value", qtyString);
        });
      }

      const legacyAtcQty =
        form.querySelector("#homeatc") || document.getElementById("homeatc");
      if (legacyAtcQty) {
        legacyAtcQty.value = qtyString;
        legacyAtcQty.setAttribute("value", qtyString);
      }
    },
    true,
  );

  document.addEventListener("submit", async function (event) {
    if (isCartPage()) return;

    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.nativeCartSubmit === "1") {
      form.dataset.nativeCartSubmit = "0";
      return;
    }

    const submitter = event.submitter || getRecentSubmitterForForm(form);

    const formAction = (form.getAttribute("action") || "").toLowerCase();
    const isAddToCartForm =
      formAction.includes("/cart/add") || formAction.endsWith("cart/add");

    if (!isAddToCartForm) return;

    if (
      form.dataset.gokwikSubmit === "1" ||
      (submitter &&
        (submitter.name === "checkout" ||
          (submitter.formAction &&
            submitter.formAction.includes("/checkout")) ||
          submitter.id === "gokwik-buy-now"))
    ) {
      return;
    }

    event.preventDefault();

    try {
      const preferredQty = getPreferredFormQuantity(form, submitter || null);
      const runtimeQty = getVisibleRuntimeQty();
      const isQuickAddSubmit = Boolean(
        submitter &&
        submitter.closest &&
        submitter.closest("product-quick-add"),
      );
      let finalQty =
        !isQuickAddSubmit &&
        Number.isFinite(runtimeQty) &&
        runtimeQty > preferredQty
          ? runtimeQty
          : preferredQty;

      // Cap quantity to what the quantity selector allows (respects inventory max).
      const qtySelector = form.querySelector("quantity-selector") ||
        document.querySelector(".shopify-section--main-product quantity-selector");
      if (qtySelector) {
        const selectorMax = parseInt(qtySelector.getAttribute("max"), 10);
        if (Number.isFinite(selectorMax) && selectorMax > 0 && finalQty > selectorMax) {
          finalQty = selectorMax;
        }
      }

      // Force real DOM fields too so any parallel theme/app handlers see the same quantity.
      const inlineQtyField = form.querySelector('[name="quantity"]');
      if (inlineQtyField) inlineQtyField.value = String(finalQty);
      if (form.id) {
        const boundQtyFields = document.querySelectorAll(
          '[name="quantity"][form="' + form.id + '"]',
        );
        boundQtyFields.forEach(function (input) {
          input.value = String(finalQty);
          input.setAttribute("value", String(finalQty));
        });
      }

      const formData = new FormData(form);
      const variantId = getPreferredFormVariantId(form);
      if (!variantId) {
        // No valid variant selected — do not submit.
        return;
      }
      formData.set("id", String(variantId));
      formData.set("quantity", String(finalQty));

      // If Buy Now was used, GoKwik cleared the cart. Restore it before adding.
      const gkSnapshot = window.__gkCartSnapshot || null;
      if (gkSnapshot) {
        window.__gkCartSnapshot = null;
        await new Promise(function (r) { setTimeout(r, 300); });
        await fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" });
        const snapshotItems = Array.isArray(gkSnapshot.items) ? gkSnapshot.items : [];
        if (snapshotItems.length > 0) {
          const restorePayload = snapshotItems.map(function (item) {
            const entry = { id: item.variant_id, quantity: item.quantity };
            if (item.properties && Object.keys(item.properties).length > 0) {
              entry.properties = item.properties;
            }
            if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
              entry.selling_plan = item.selling_plan_allocation.selling_plan.id;
            }
            return entry;
          });
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ items: restorePayload }),
          });
        }
      }

      await addProductAndPreserveExistingQuantity(formData);

      openCartDrawer();
      syncCartAfterChange(true).catch(function () {
        window.location.reload();
      });
    } catch (error) {
      if (error && error.suppressNativeSubmit) {
        syncCartAfterChange(true).catch(function () {
          window.location.reload();
        });
        return;
      }
      form.dataset.nativeCartSubmit = "1";
      if (submitter && typeof form.requestSubmit === "function") {
        form.requestSubmit(submitter);
      } else {
        form.submit();
      }
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      updateMinusButtonState(document.querySelector(CART_DRAWER_SELECTOR));
      syncCartMeta();
      // refreshCartDrawerFromSection() intentionally NOT called on initial load —
      // the server-rendered cart drawer is always current; calling it here causes
      // an unnecessary innerHTML replacement right after load which triggers a
      // header repaint (visible flicker). It is still called after every cart op.
    });
  } else {
    updateMinusButtonState(document.querySelector(CART_DRAWER_SELECTOR));
    syncCartMeta();
  }
})();
